// Valorile implicite globale ale componentelor Vuetify — stratul „componentă” din
// docs/design/foundations.md. Stilul unui tip de element se schimbă AICI, o singură dată,
// nu prin props repetate în fiecare fișier .vue (vezi docs/design/ui-kit.md).
//
// Ordinea de rezolvare Vuetify: prop explicit → defaults pe componentă → defaults globale →
// valoarea componentei. Cheile cu majusculă dintr-o componentă (ex. VDialog.VCard) se aplică
// doar copiilor ei.

const FIELD_DEFAULTS = { variant: "outlined", density: "comfortable" };

// Overlay-urile (dialog, meniu, bottom sheet) plutesc peste pagină: cardul din interior păstrează elevația,
// în timp ce cardurile de conținut de pe pagină folosesc bordura subtilă (brand book 07).
const OVERLAY_CARD_DEFAULTS = { VCard: { variant: "elevated" } };

// Obiect simplu (nu `Object.freeze`): Vuetify îl împachetează într-un `ref` reactiv.
export const VUETIFY_DEFAULTS = {
  // Brand book 08: acțiunea standard este plină, fără umbră; `elevated` (implicitul Vuetify) nu se folosește.
  VBtn: { variant: "flat" },
  // Brand book 07: bordură subtilă + varianta outlined în locul elevației.
  VCard: { variant: "outlined" },
  VDialog: OVERLAY_CARD_DEFAULTS,
  VMenu: OVERLAY_CARD_DEFAULTS,
  VBottomSheet: OVERLAY_CARD_DEFAULTS,
  VTextField: FIELD_DEFAULTS,
  VTextarea: FIELD_DEFAULTS,
  VSelect: FIELD_DEFAULTS,
  VAutocomplete: FIELD_DEFAULTS,
  VCombobox: FIELD_DEFAULTS,
  VFileInput: FIELD_DEFAULTS,
  VChip: { variant: "tonal", size: "small" },
  VAlert: { variant: "tonal" },
  VSnackbar: { variant: "tonal" },
};
